import React from "react";
import DOMPurify from 'dompurify';
import { ucfirst, strstr, str_replace } from './Utilities';

/*
 * Class that displays relevant errors on all dashboard reports
 *
 */

class ReportsError extends React.Component {

	constructor(props) {
        super(props);
        this.state = {
        	message: null,
        	type: props?.type || "members",
        	hash: props?.hash || "",
        	isTable: props?.table || true,
        	styles: props?.styles || {}
        };
    }

	componentDidMount() {
		this.setErrorMessage();
	}

	setErrorMessage() {
		var message = "";
		if(this.props.error){
			message = ucfirst(this.props.error);
		} else {
			message = `No ${this.state.type} found that match that criteria. <a href='/dashboard/reports${this.state.hash}'>Change your filters?</a>`;
		}

		if(strstr(message, "Insufficient datacred balance")){
			message = str_replace(" [top up to at least 1000 datacreds]", ". <a href='/dashboard/addfunds'>Top up to at least 1000 DataCreds</a>.", message);
		}
	
		this.setState({
			message: message
		});
	}

	render() {
		if(this.state?.isTable === "false"){
			return (
				<div className="dashboard-report-error" style={this.state.styles}>
	                <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.state.message) }}></p>
	            </div>
			);
		} else {
			return (
				<tbody className="dashboard-report-error" style={this.state.styles}>
	                <tr>
	                    <td colSpan="7" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.state.message) }}></td>
	                </tr>
	            </tbody>
			);
		}
	}

}

export default ReportsError;